import React, { Suspense, lazy, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { getHeader, getfooter, gethome } from './store/homeAction/action';
import { useStateValue } from "./store";
import "./App.scss";
import "./variables/colorVariables.module.scss";

import Home from "./page/home";
import RiskFall from "./page/riskFall";
import AssessmentLanding from "./page/assessmentLanding";
import AssessmentQuestion from "./page/assessment"
import Score from "./page/score";
import ScrollToTop from "./common/scrollToTop";
import SimpleLoader from "./component/loader"
import Layouts from "./page/layouts";
import BundleLayout from "./page/bundleLayout";
import MyCart from "./page/myCart";
import BundleListing from "./page/bundleListing";
import ProductDetail from "./page/productDetail";
import Alert from "./common/alert"
import CartPopup from "./component/cart/cartPopup";
import EmailPopup from "./component/popupModal";
import ZipCodePopup from "./component/zipcodePopup";
import HelpingPopup from "./component/header/helpPopup"
import Checkout from "./page/checkout";
import OrderConfirmation from "./page/orderConfirmation";
import ServicePopupModal from "./component/checkout/servicePopupModal";

const Header = lazy(() => import("./component/header"));
const Footer = lazy(() => import("./component/footer"));

const App = () => {
  const [
    { header, footer, cartAlert, home,
      isLoading, zipCodePopup, alertMessage, emailPopup, helpingPopup, servicePopup },
    dispatch,
  ] = useStateValue();

  let completedCallbacks = 0;

  const handleCallback = () => {
    completedCallbacks++;

    if (completedCallbacks === 3) {
      // Dispatch loader action here
      dispatch({
        type: "SET_IS_LOADING",
        value: false,
      });
    }
  };

  const ErrorMessage = (error) => {
    dispatch({
      type: "SET_ALERT_MESSAGE",
      value: true,
      data: {
        severity: "error",
        message: "Something went wrong, Please try again.",
      },
    });

  }
  useEffect(() => {
    getHeader((res, error) => {
      dispatch({
        type: "SET_HEADER",
        data: res,
      });
      if (error) {
        ErrorMessage(error)
      }
      handleCallback();
    });
    gethome((res, error) => {
      dispatch({
        type: "SET_HOME",
        data: res,
      });
      if (error) {
        ErrorMessage(error)
      }
      handleCallback();
    });
    getfooter((res, error) => {
      dispatch({
        type: "SET_FOOTER",
        data: res,
      });
      if (error) {
        ErrorMessage(error)
      }
      handleCallback();
    });
    if (window.location.pathname === `${process.env.REACT_APP_BASE}/`) {
      dispatch({
        type: "SET_IS_LOADING",
        value: true,
      });
    }
  }, []);
  const base = process.env.REACT_APP_BASE

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Suspense fallback={null}>
          <Router>
            <Header data={header} />
            <Routes>
              <Route path={`${base}/`} element={<> <Home data={home} /> <ScrollToTop /> </>} exact />
              <Route path={`${base}/risk-fall`} element={<> <RiskFall /> <ScrollToTop /> </>} exact />
              <Route path={`${base}/assessment`} element={<> <AssessmentLanding /> <ScrollToTop /> </>} exact />
              {/* {!JSON.parse(sessionStorage.getItem("qtnValues"))?.question ? */}
              <Route path={`${base}/assessment/:question`} element={<> <AssessmentQuestion /> <ScrollToTop /> </>} exact />
              {/* // : ""} */}
              {/* {JSON.parse(sessionStorage.getItem("qtnValues")) ? */}
              {/* <> */}
              <Route path={`${base}/assessment-result`} element={<> <Score /> <ScrollToTop /> </>} exact />
              <Route path={`${base}/layout`} element={<> <Layouts /> <ScrollToTop /> </>} exact />
              <Route path={`${base}/bundle`} element={<> <BundleLayout /> <ScrollToTop /> </>} exact />
              <Route path={`${base}/bundle-listing`} element={<> <BundleListing /> <ScrollToTop /> </>} exact />
              <Route path={`${base}/product-details`} element={<> <ProductDetail /> <ScrollToTop /> </>} exact />
              <Route path={`${base}/mycart`} element={<> <MyCart /> <ScrollToTop /> </>} exact />
              <Route path={`${base}/checkout`} element={<> <Checkout /> <ScrollToTop /> </>} exact />
              <Route path={`${base}/order-status`} element={<> <OrderConfirmation /> <ScrollToTop /> </>} exact />
              {/* </> */}
              {/* : */}
              {/* <Route path="*" element={<Navigate to="/" replace />} exact /> */}
              {/* } */}
            </Routes>
            {Object.keys(footer).length !== 0 ?
              <Footer data={footer} base={base} /> : null}
            {isLoading && <SimpleLoader />}
            {alertMessage?.isOpen && <Alert />}
            {cartAlert?.isOpen && <CartPopup />}
            {emailPopup?.isOpen && <EmailPopup />}
            {zipCodePopup?.isOpen && <ZipCodePopup />}
            {helpingPopup?.isOpen && <HelpingPopup />}
            {servicePopup?.isOpen && <ServicePopupModal />}
          </Router>
        </Suspense>
      </ThemeProvider>
    </div>
  );
};

export default App;
